import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <p-confirmDialog #cd [style]="{width: '50vw'}" [baseZIndex]=10000>
        <ng-template pTemplate="header">
            <h3>Header content</h3>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template>
    </p-confirmDialog>
  `,
  styleUrls: ['./confirmation-dialog.component.css']
})


export class ConfirmationDialogComponent implements OnInit {
  
  constructor() {
   }
  ngOnInit() {
  }
}
